import classnames from 'classnames';
import { Link } from 'gatsby';
import React, { ReactNode } from 'react';

import { ReactComponent as RightArrow } from '../../assets/right-arrow.svg';
import {
	container as containerStyle,
	link as linkStyle,
	rule as ruleStyle,
} from './style.module.css';

export interface NextArticleProps {
	title1?: string | null;
	title2?: string | null;
	slug?: string | null;
}

export const NextArticle = ({ title1, title2, slug }: NextArticleProps): JSX.Element => {
	return (
		<section className={containerStyle}>
			<div className={ruleStyle}></div>
			{!!title1 && <h2>{title1}:</h2>}
			<Link to={`/${slug}`}>
				{!!title2 && <h1>{title2}</h1>}

				{/* Link with arrow */}
				{!!slug && (
					<div className={linkStyle}>
						<span>Learn more</span>
						<RightArrow />
					</div>
				)}
			</Link>
		</section>
	);
};
